const v27 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        freelancersTable: {
          ...state.options.tableViews.freelancersTable,
          'Current Hour Wage': true,
          'Current Day Wage': true,
          'Current Month Wage': true,
          'Current Single Job Wage': true,
        },
      },
    },
  };
};

export default v27;
